import { createContext, useContext } from "react";

interface PageShellContextValue {
  isMobileNavOpen: boolean;
  openMobileNav: () => void;
  closeMobileNav: () => void;
}

export const PageShellContext = createContext<PageShellContextValue | null>(
  null,
);

export function usePageShell(): PageShellContextValue {
  const ctx = useContext(PageShellContext);
  if (!ctx)
    throw new Error("usePageShell must be used inside <PageShell> layout");
  return ctx;
}
